import image1 from "../../assets/img/Carousel/1.webp"
import image2 from "../../assets/img/Carousel/2.webp"
import image3 from "../../assets/img/Carousel/3.webp"
import image4 from "../../assets/img/Carousel/4.webp"
import image5 from "../../assets/img/Carousel/5.webp"
import image6 from "../../assets/img/Carousel/6.webp"
import image7 from "../../assets/img/Carousel/7.webp"

export const images = [
    {
        id: 0,
        source: image1,
    },
    {
        id: 1,
        source: image2,
    },
    {
        id: 2,
        source: image3,
    },
    {
        id: 3,
        source: image4,
    },
    {
        id: 4,
        source: image5,
    },
    {
        id: 5,
        source: image6,
    },
    {
        id: 6,
        source: image7,
    },
]